import { formatTimeWindow } from 'common/TimeWindowUtils';
import { TimeWindowSelectorTimeWindowFragment } from 'src/gqlReactTypings.generated.d';

export type TimeWindow = Pick<
  TimeWindowSelectorTimeWindowFragment,
  'id' | 'startMsAfterMidnight' | 'endMsAfterMidnight'
>;

export const formatTimeWindowForPage = (timeWindow: TimeWindow): string =>
  formatTimeWindow(timeWindow.startMsAfterMidnight, timeWindow.endMsAfterMidnight, {
    joiner: '-',
    amMeridiemIndicator: ' am',
    pmMeridiemIndicator: ' pm',
    includeMinutes: true,
    smartMeridiemIndicator: true,
  });
